<template>
  <div>
    <span @click="search()">
      <Button
        type="primary"
        @click="modal1 = true"
        v-hasPermission="['alarm_contact:AlarmContact:create']"
        >{{ $t("alarm_contact.addAlarmContact") }}</Button
      >
    </span>
    <Modal
      v-model="modal1"
      :title="$t('alarm_contact.addAlarmContact')"
      :loading="loading"
      @on-ok="alarmContactSubmit('alarmContactForm')"
      @on-cancel="alarmContactReset('alarmContactForm')"
      :mask-closable="false"
      :okText="$t('alarms.common.add')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="alarmContactForm"
        :model="alarmContactForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 公司 -->
        <div v-if="company == 1">
          <FormItem :label="$t('alarm_contact.companyName')" prop="companyId">
            <Select
              filterable
              v-model="companyId"
              style="width: 260px"
              @on-change="queryAlertRuleByUser()"
              placeholder=""
            >
              <Option
                :value="item.id"
                v-for="(item, index) in companyList"
                v-bind:key="index"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
        </div>

        <!-- 用户 -->
        <FormItem :label="$t('alarm_contact.name')" prop="userId">
          <Select
            filterable
            v-model="alarmContactForm.userId"
            style="width: 260px"
            @on-change="changeUserId(alarmContactForm.userId)"
            placeholder=""
          >
            <Option
              :value="item.id"
              v-for="item in alertUserList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 监控模块 -->
        <FormItem
          :label="$t('alarm_contact.monitorModule')"
          prop="monitorModule"
        >
          <Select
            filterable
            v-model="alarmContactForm.monitorModule"
            multiple
            style="width: 260px"
            placeholder=""
          >
            <Option
              :value="item.id"
              v-for="item in monitorModuleList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 电话 -->
        <FormItem :label="$t('alarm_contact.phone')" prop="phone">
          <Input
            style="width: 260px"
            v-model="alarmContactForm.phone"
            placeholder="请输入电话"
          />
        </FormItem>
        <!-- 绑定状态 -->
        <FormItem
          :label="$t('alarm_contact.bindingStatus')"
          prop="whetherToBind"
          v-show="isBind"
          >{{ alarmContactForm.whetherToBind }}
          <a @click="cancelBind">{{ $t("alarm_contact.unBind") }}</a></FormItem
        >

        <!-- 个人微信 -->
<!--        <FormItem-->
<!--          :label="$t('alarm_contact.personalWeChat')"-->
<!--          prop="personalWeChat"-->
<!--          v-show="isPersonWechat"-->
<!--        >-->
<!--          <img :src="alarmContactForm.personalWeChat" style="width: 250px" />-->
<!--        </FormItem>-->

        <!-- 默认联系人 -->
        <FormItem :label="$t('alarm_contact.defaultContact')" prop="isDefault">
          <RadioGroup v-model="alarmContactForm.isDefault">
            <Radio
              v-for="list in isDefaultList"
              :label="list.isDefault"
              :key="list.value"
              >{{ list.label }}</Radio
            >
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import TableAlarmContact from "../alarm_contact/TableAlarmContact.vue";

var tableAlarmContact = TableAlarmContact;
export default {
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      email: "",
      name: "",
      dept: "",
      position: "",
      isBind: false,
      isPersonWechat: false,
      alarmContactForm: {
        userId: "",
        monitorModule: [],
        phone: "",
        isDefault: "0",
        personalWeChat: "",
        whetherToBind: ""
      },
      isDefaultList: [
        {
          label: this.$t("alarm_contact.yes"),
          value: "is",
          isDefault: "1"
        },
        {
          label: this.$t("alarm_contact.no"),
          value: "no",
          isDefault: "0"
        }
      ],
      // 监控模块
      monitorModuleList: [],
      // 用户集合
      alertUserList: [],
      loading: true,
      modal1: false,
      ruleValidate: {
        userId: [
          {
            required: true,
            message: "请选择用户",
            trigger: "change",
            type: "number"
          }
        ],
        monitorModule: [
          {
            required: true,
            message: "请选择监控模块",
            trigger: "change",
            type: "array"
          }
        ],
        isDefault: [
          { required: true, message: "请选择默认联系人", trigger: "change" }
        ]
      }
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    } else {
      this.queryAlertRuleByUser();
    }
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // Change Company Event
    queryAlertRuleByUser: function() {
      this.alertUserList = [];
      this.alarmContactForm.userId = "";
      this.$api.user
        .queryAlertRuleByUser("companyId", this.companyId)
        .then(res => {
          if (res.data != null && res.data != "" && res.data.length > 0) {
            this.alertUserList = res.data;
          }
        });
    },
    // 查询监控模块和报警用户
    search: function() {
      this.$api.alertRule
        .searchMonitorModule("userName", getCookie(global.cookieName))
        .then(res => {
          this.monitorModuleList = res.data;
        });
    },
    //查询用户联系信息
    changeUserId: function() {
      if (this.alarmContactForm.userId == undefined) {
        return;
      }
      this.$api.user
        .queryUserContactInformation("userId", this.alarmContactForm.userId)
        .then(res => {
          this.email = res.data.email;
          this.name = res.data.name;
          this.dept = res.data.department;
          this.position = res.data.position;
        });

      this.checkCurrentUserIsBindWeChat();
    },
    // 检查当前用户是否已经绑定过微信
    checkCurrentUserIsBindWeChat: function() {
      if (this.alarmContactForm.userId == undefined) {
        return;
      }
      this.$api.userWeChat
        .checkCurrentUserIsBindWeChat("userId", this.alarmContactForm.userId)
        .then(res => {
          if (res.data) {
            // 已经绑定微信
            this.isBind = true;
            this.isPersonWechat = false;
            this.alarmContactForm.whetherToBind = "已绑定";
          } else {
            // 没有绑定微信
            this.showQrCode();
            this.isBind = false;
            this.isPersonWechat = true;
          }
        });
    },
    // 取消绑定
    cancelBind: function() {
      this.$api.userWeChat
        .unbindWeChat("userId", this.alarmContactForm.userId)
        .then(res => {
          this.$Message.success("解绑成功");
        });
    },
    // 获取二维码
    showQrCode: function() {
      this.$api.callWechatServer
        .showQrCode("userId", this.alarmContactForm.userId)
        .then(response => {
          return (
            "data:image/jpeg;base64," +
            btoa(
              new Uint8Array(response.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            )
          );
        })
        .then(res => {
          this.alarmContactForm.personalWeChat = res; //赋值给img标签的src属性
        });
    },
    alarmContactSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 添加联系人
          this.$api.contact
            .createContact({
              companyId:
                this.companyId == null ||
                this.companyId == "" ||
                this.companyId == undefined
                  ? this.company
                  : this.companyId,
              userId: this.alarmContactForm.userId,
              name: this.name,
              dept: this.dept,
              position: this.position,
              email: this.email,
              monitorModules: this.alarmContactForm.monitorModule,
              phone: this.alarmContactForm.phone,
              isDefault: this.alarmContactForm.isDefault
            })
            .then(res => {
              this.data = res.data;
              setTimeout(() => {
                tableAlarmContact.methods.showAll();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success("添加成功");
                this.isBind = false;
                this.isPersonWechat = false;
                this.modal1 = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error("添加失败");
        }
      });
    },
    alarmContactReset: function(name) {
      this.isBind = false;
      this.isPersonWechat = false;
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/alarm_contact/alarm_contact/AddAlarmContact.vue